import { IGroupInfo } from "@home-health-notify/domain";
import { ChatInfoContext } from "hhn-commons";
import { useContext } from "react";
import { CareTimelineWrapper } from "./CareTimeline.style";
import CareTimelineItem from "./CareTimelineItem";
import PatientGroupDetails from "./PatientGroupDetails";

const CareTimeline = () => {
  const { chat } = useContext(ChatInfoContext);
  const groupInfo = chat?.chatInfo as IGroupInfo;

  return (
    <>
      {chat && (
        <CareTimelineWrapper>
          <PatientGroupDetails groupInfo={groupInfo} />
          {groupInfo?.timeline.map((timelineItem, i) => (
            <CareTimelineItem
              key={timelineItem.type + i}
              timelineItem={timelineItem}
            />
          ))}
        </CareTimelineWrapper>
      )}
    </>
  );
};
export default CareTimeline;
